export default {
  Title: {
    GenerateAccountTransfer: 'Sinh phiếu kết chuyển tài khoản',
  },

  Message: {
    GenerateAccountTransfer:
      'Đã sinh chứng từ Phiếu kết chuyển tài khoản <span class="customCallBack" style="color: #0078d7;cursor:pointer;">{0}</span>. Bạn có muốn xem chứng từ này không?',
  },
};
